export class LocalStorageUtils {
  static isOnTerminal() {
    const storedData = localStorage.getItem('authData');
    if (!storedData) return false;
    const parsed = JSON.parse(storedData);
    const accessContext = parsed.accessContext;
    return accessContext === 'TERMINAL';
  }

  static isRefreshNeeded(): boolean {
    const storedData = localStorage.getItem('authData');
    return !storedData;
  }
}
